// extracted by mini-css-extract-plugin
export default {"container":"ChatsModal_container__scrcy","content":"ChatsModal_content__XkMqd"};